module.exports = __webpack_public_path__ + "static/media/Sleekflow_logo_white_2x.ee6fcadf.svg";